import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white px-6 lg:px-8" data-id="element-110">
      <div className="max-w-3xl mx-auto bg-brand-navy rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden shadow-soft-lg" data-id="element-111">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-accent" data-id="element-112"></div>

        <ShieldCheck className="w-16 h-16 text-brand-accent mx-auto mb-6" data-id="element-113" />

        <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-114">
          Garantía 7 días, sin preguntas
        </h2>

        <p className="text-lg text-white/80 mb-6" data-id="element-115">
          Entrá, descargá el material, mirá los módulos. Si sentís que no te
          suma valor o que no aplica a tu forma de trabajar, mandás un mail y te
          devolvemos el 100% de tu dinero.
        </p>

        <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full text-sm font-medium" data-id="element-116">
          <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-117"></span>
          Tasa de devolución real menor al 1%
        </div>
      </div>
    </section>;
}